<template>
  <BaseWarning>
    <i18n path="warnings.noSuitablePartnership.baseWarning" tag="span">
      <template #inPitchArea>
        <a :href="infoURLs[data.pitchArea]" target="_blank">
          {{ pitchArea }}
        </a>
      </template>
    </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from "./BaseWarning.vue";

export default {  
  props: {
    data: Object
  },

  components: { BaseWarning },

  data: function() {
    return {
      infoURLs: {
        centralAttack: "https://www.guidetofm.com/tactics/role-combinations/",
        centralMidfield: "https://www.guidetofm.com/tactics/choosing-roles-duties/3/#forward-movement-partnerships",
        rightFlank: "https://www.guidetofm.com/tactics/choosing-roles-duties/4/#forward-movement-partnerships-2",
        leftFlank: "https://www.guidetofm.com/tactics/choosing-roles-duties/4/#forward-movement-partnerships-2",
      },
    }
  },

  computed: {
    pitchArea: function() {
      const key = `in${this.data.pitchArea.charAt(0).toUpperCase()}${this.data.pitchArea.slice(1)}`;
      return this.$t(`tactics.pitchAreas.${key}`)
    },
  },
};
</script>
